import { makeService } from './api';

const service = makeService('discounts');

export default service;